import React, {Component} from 'react';
import {connect} from 'react-redux';
import PayerSelect from "../invoice/PayerSelect";
import ManagePaymentMethods from "./manage-payment-methods/ManagePaymentMethods";
import * as appConstants from "../../constants/ApplicationConstants";
import {AccountType} from "../../interfaces/Accounts";
import {FinalizePaymentProcess} from "./manage-payment-methods/FinalizePaymentProcess";

export class AccountPaymentPage extends Component<any, any> {

  render() {
    const isSoldToAccount = this.props.accountType === AccountType.SoldTo;
    return <div className={'container'}>
      <FinalizePaymentProcess/>
      <div className="row mb-4">
        <div className="col-md-6">
          {isSoldToAccount ? <PayerSelect name={'payer_option'}/>: ''}
        </div>
      </div>
      <div className="card">
        <ManagePaymentMethods alwaysSaveOnFile={true}/>
      </div>
    </div>
  }
}

export default connect<any, any, any, any>((state, props) => {
  return {
    accountType: state.user_options.accountType,
  }
})(AccountPaymentPage);
